import {Component, Input} from "@angular/core";
import {Router} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-st-banner',
  templateUrl: './st-banner.component.html',
  styleUrls: ['./st-banner.component.scss'],
  standalone: false
})
export class StBannerComponent {

  @Input()
  idVal: string = 'banner-id';

  @Input()
  breadCrumbs: any[] = [];

  @Input()
  scrollNavBarId: string = 'scroll-nav-bar-id';

  @Input()
  hasElementTags: boolean = false;

  @Input()
  elementTags: any = [];

  @Input()
  requiresSignOutButton: boolean = false;

}
